import { Stack } from '@mui/material';

import MiniScreen from '@/designs-dev/handover/MiniScreen';
import { Frame, LibraryShell } from '@/designs-dev/library/LibraryCanvas';
import { patternsSpec } from '@/karehero-app/handover/patterns';

/**
 * The patterns the library holds, taken from the Patterns flows page by id, so
 * the two show the same screen and say the same thing about it.
 */
const PATTERN_IDS = [
  // Named as the Storybook plan names it. The mini keeps the Patterns page's.
  { id: 'edit-in-a-drawer', title: 'Edit in a drawer' },
];

const patterns = PATTERN_IDS.map(({ id, title }) => {
  const found = patternsSpec.patterns?.find((p) => p.id === id);
  if (!found)
    throw new Error(`No pattern with id "${id}" on the Patterns page`);
  return { ...found, title };
});

/** Patterns: how components combine for a common job. */
const PatternsCanvas = () => (
  <LibraryShell title='Patterns'>
    <Stack direction='row' spacing={6} sx={{ alignItems: 'flex-start' }}>
      {patterns.map((p) => (
        <Frame key={p.id} title={p.title}>
          <MiniScreen
            label={p.name}
            caption={p.when}
            variant={p.screen ?? 'phone'}
            pointer={{ kind: 'Pattern', id: p.id }}
          >
            {p.render()}
          </MiniScreen>
        </Frame>
      ))}
    </Stack>
  </LibraryShell>
);

export default PatternsCanvas;
